import { Label } from '@fluentui/react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { ActionButton, Stack } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataDocument } from '../../../data/DataDocument';
import { EUISeparator } from '../../EUI/EUISeparator';

class Message extends Component {

    _classNames = mergeStyleSets({
        dateEnvoi: {
            fontSize: "0.75rem",
            fontStyle: "italic",
        },
        quote: {
            borderBottom: "1px solid currentColor",
            borderTop: "1px solid currentColor",
            fontSize: "0.75rem",
            fontStyle: "italic",
            margin: "3px inherit",
        },
        messagefont: {
            fontWeight: "normal"
        }
    });

    _styles = {
        downloadButton: {
            root: { color: "inherit", height: "25px" },
            rootHovered: { color: "inherit" },
            rootFocused: { outline: "none" },
            icon: { color: "inherit" },
            iconHovered: { color: "inherit", fontWeight: "bold" }
        },
        fileIcon: { root: { fontSize: "20px" } },
        replyButton: {
            root: {
                fontSize: "0.75rem",
                fontStyle: "italic",
                height: "unset"
            }
        },
        messageEnvoye: {
            root: {
                backgroundColor: "#e0e1d3",
                borderRadius: "5px",
                color: "black",
                padding: "12.5px 20px",
                maxWidth: "80%",
            }
        },
        messageRecu: {
            root: {
                backgroundColor: "#f4f7f9",
                borderRadius: "5px",
                color: "#263238",
                padding: "12.5px 20px",
                maxWidth: "80%"
            }
        }
    };

    _telechargerDocument = (rowGUID, nom) => () => {
        DataDocument._onTelechargementDocument(rowGUID).then((responseFetch) => {
            if (responseFetch.codeRetour === 0) {
                const objetData = responseFetch.reponseAPIobjet;
                const fichier = Scriba.fichier().Base64VersByteArray(objetData.fileData);
                Scriba.fichier().EnregisterSous(fichier, nom);
            }
        });
    };

    _getMessageAlignment = () => {
        if (this.props.message.loginCompte)
            if (this.props.adminMode) return "end";
            else return "start";
        else
            if (this.props.adminMode) return "start";
            else return "end";
    };

    _getMessageStyles = () => {
        if (this.props.message.loginCompte)
            if (this.props.adminMode) return this._styles.messageEnvoye;
            else return this._styles.messageRecu;
        else
            if (this.props.adminMode) return this._styles.messageRecu;
            else return this._styles.messageEnvoye;
    };

    render = () => {
        const { message, adminMode } = this.props;
        const { dateEnvoi, piecesJointes, texte, loginCompte, idMessageParent, texteMessageParent } = message;

        return <Stack.Item styles={this._getMessageStyles()} align={this._getMessageAlignment()}>
            <Stack horizontal verticalAlign="center" gap={15}>
                <Stack.Item grow className={this._classNames.dateEnvoi}>{Scriba.date().stringDateHeureFormatCourt(dateEnvoi)}</Stack.Item>
                {
                    (adminMode ? !loginCompte : loginCompte) && // On ne peut se répondre à soi-même
                    <ActionButton iconProps={{ iconName: "Reply" }} onClick={this.props.onSelectionMessage} styles={this._styles.replyButton}>
                        Répondre
                    </ActionButton>
                }
            </Stack>
            {
                !!piecesJointes && Array.isArray(piecesJointes) && piecesJointes.length > 0 && <Stack>
                    <EUISeparator />
                    {piecesJointes.map((pieceJointe, index) => {
                        const { nom, rowGUID } = pieceJointe;
                        return <ActionButton key={index} iconProps={{ iconName: "Download" }} onClick={this._telechargerDocument(rowGUID, nom)} styles={this._styles.downloadButton} >
                            {nom}
                        </ActionButton>
                    })}
                    <EUISeparator />
                </Stack>
            }
            {idMessageParent && <div className={this._classNames.quote}>En réponse au message : {texteMessageParent || "< Pièce jointe uniquement >"}</div>}
            <div>
                <Label className={this._classNames.messagefont}>{texte != null ? texte.split("\n").map((l, idx, ary) => {
                    if (ary.length == idx + 1) {
                        return (<span key={idx}>{l}</span>);
                    }
                    return (<div key={idx}><span>{l}</span><br /></div>)
                }) : ''}
                </Label>
            </div>
        </Stack.Item>
    };

}

export default Message